import type { SVGProps } from 'react';
const SvgLogoutSidebar = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#logout-sidebar_svg__a)">
      <path
        fill="currentColor"
        fillOpacity={0.88}
        d="M14.357 11.93h-1.255a.28.28 0 0 0-.22.103 6.32 6.32 0 0 1-4.875 2.29 6.3 6.3 0 0 1-4.475-1.853 6.3 6.3 0 0 1-1.357-2.008A6.3 6.3 0 0 1 1.68 8a6.3 6.3 0 0 1 1.853-4.47A6.32 6.32 0 0 1 8.007 1.68a6.318 6.318 0 0 1 4.875 2.29.28.28 0 0 0 .22.103h1.255a.142.142 0 0 0 .12-.22 7.68 7.68 0 0 0-6.49-3.53A7.67 7.67 0 0 0 .323 8.08a7.683 7.683 0 0 0 7.685 7.6 7.68 7.68 0 0 0 6.47-3.53.143.143 0 0 0-.12-.22m1.588-4.042-2.534-2a.143.143 0 0 0-.232.113v1.357H7.572a.143.143 0 0 0-.143.143v1c0 .078.064.143.143.143h5.607V10c0 .12.14.187.232.112l2.534-2a.143.143 0 0 0 0-.225"
      />
    </g>
    <defs>
      <clipPath id="logout-sidebar_svg__a">
        <path fill="#fff" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLogoutSidebar;
